<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-25 09:38:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-15 16:59:20
-->
<template>
  <div class="box">
    <div class="search">
      <div class="left">
        <div v-if="codeData.indexOf('31') != -1" class="batch-operation">
          <a-dropdown>
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item v-if="codeData.indexOf('33') != -1" key="1"> 还原</a-menu-item>
              <a-menu-item  v-if="codeData.indexOf('34') != -1" key="2"> 删除</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /> </a-button>
          </a-dropdown>
        </div>
      </div>
      <div class="right">
        <el-select
          multiple
          clearable
          style="width: 300px"
          v-model="value"
          placeholder="按模型选择"
        >
          <el-option
            v-for="(item, index) in listPageData"
            :label="item.modelName"
            :value="item.id"
            :key="index"
          >
          </el-option>
        </el-select>
        <a-input-group compact>
          <a-select
            v-model:value="selectName"
            style="width: 140px; background: #ccc; margin-left: 12px"
          >
            <a-select-option
              @click="selectFn(item.value)"
              :key="index"
              v-for="(item, index) in selectArr"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
          <a-input
            v-model:value="valueName"
            placeholder="请输入搜索内容"
            style="width: 173px"
          />
        </a-input-group>
       <el-button  @click="listSearch" type="primary" 
          >查询</el-button 
        >
      </div>
    </div>
    <coententTable
      :y="height"
      @handleTableChange="handleTableChange"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :customSlot="customSlot"
      :isSelectRow="isSelectRow"
      @selectedRowKeys="selectedRowKeys"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
      :rowKeys="rowKeys"
    >
    <template v-slot:columnName="scopeVal">
        <div
          @click="openColumn(scopeVal.scope)"
          v-if="scopeVal.scope.number && codeData.indexOf('177') != -1"
          class="column-style"
        >
          <el-popover
            placement="left-start"
            title=""
            width="380"
            @show="showData(scopeVal.scope.id)"
            trigger="hover"
          >
            <div>
              <div class="title-top">
                <div class="title-top-left">预览关联栏目</div>
                <div class="title-top-right">点击标签操作发布和下线</div>
              </div>
              <div class="item-one" v-for="(item, index) in showDataReq">
                {{ index + 1 }}. {{ item.parentsName.split(",").join(">") }}
              </div>
            </div>
            <el-button class="column-number" slot="reference"
              >共{{ scopeVal.scope.number }}个</el-button
            >
          </el-popover>
        </div>
        <div class="column-numberTwo" v-if="!scopeVal.scope.number">-</div>
      </template>
      <template v-slot:state="scopeVal">
        {{
          scopeVal.scope.state == 0
            ? "草稿"
            : scopeVal.scope.state == 1
            ? "审核中"
            : scopeVal.scope.state == 2
            ? "审核通过"
            : scopeVal.scope.state == 3
            ? "审核失败"
            : scopeVal.scope.state == 4
            ? "已发布"
            : "下线"
        }}
      </template>
      <template v-slot:stateRizhi="scopeVal">
        <a-popover trigger="click">
          <div class="content" slot="content">
            <div class="open-style" v-for="(item, index) in seeData">
              <div>操作人: {{ item.name || "--" }}</div>
              <div>操作时间: {{ item.time || "--" }}</div>
              <div>描述: {{ item.content || "--" }}</div>
            </div>
          </div>
          <a v-if="codeData.indexOf('32') != -1"  @click="see(scopeVal.scope)">查看</a>
        </a-popover>
      </template>
      <template v-slot:operation="scopeVal">
         <div style="display: flex">
             <div
                v-if="codeData.indexOf('33') != -1"
                @click="reductionOne(scopeVal.scope)"
                class="btnTwo"
                style="margin-right:20px"
                >还原</div
              >
              <div
                v-if="codeData.indexOf('34') != -1"
                @click="open(scopeVal.scope)"
                class="btnThree"
                >删除</div
              >
            <el-popover v-else placement="left-start" trigger="hover">
                <div>
                  <div>需将稿件在所有栏目中下线后才可删除</div>
                </div>
                <el-button class="btnFour" slot="reference">删除</el-button>
              </el-popover>
         </div>
      </template>
    </coententTable>
    <el-dialog
        title="确认删除稿件?"
        :visible.sync="dialogVisibleTwo"
        width="450px"
        custom-class="tips-box"
        :before-close="handleClose"
        top="17%"
        >
        <span
            >确认删除此条稿件吗</span
        >
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleTwo = false">取消</el-button>
            <el-button type="danger" @click="deleteOne()"
            >确认删除</el-button
            >
        </span>
        </el-dialog>
        <el-dialog
      title="查看关联栏目"
      :visible.sync="dialogVisibleColum"
      width="535px"
      class="column-box"
      :before-close="handleCloseColum"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >若需彻底删除栏目关联，请到稿件编辑中进行设置
      </div>
      <coententTable
        :columns="columnsTwo"
        :dataSource="dataSourceColunm"
        :customSlot="customSlotTwo"
        :y="300"
      >
        <template v-slot:state="scopeVal">
          {{
          scopeVal.scope.state == 0
            ? "草稿"
            : scopeVal.scope.state == 1
            ? "审核中"
            : scopeVal.scope.state == 2
            ? "审核通过"
            : scopeVal.scope.state == 3
            ? "审核失败"
            : scopeVal.scope.state == 4
            ? "已发布"
            : "下线"
        }}
        </template>
        <template v-slot:operation="scopeVal">
          <a
           v-if="scopeVal.scope.state == 2 || scopeVal.scope.state == 5"
            @click="release(scopeVal.scope)"
            class="btn"
            >发布</a
          >
          <span v-if="scopeVal.scope.state == 4" style="color:#ccc">发布</span>
          <a
           v-if="scopeVal.scope.state == 4"
            @click="Offline(scopeVal.scope)"
            style="margin-left: 20px"
            class="btn"
            >下线</a
          >
           <span  v-if="scopeVal.scope.state == 2 || scopeVal.scope.state == 5" style="color:#ccc;margin-left: 20px">下线</span>
        </template>
      </coententTable>
    </el-dialog>
  </div>
</template>

<script>
import {
  listPage,
  selectListById,
  examineFail,
  reduction,
  recycleByDelete,
  selectRecycleListPage,
   selectList,
  toColumnExamine,
  toColumnOffline
} from "../all_manuscripts";
import coententTable from "@/components/coentent_table.vue";
import { message } from 'ant-design-vue';
export default {
  data() {
    return {
      selectName: "标题",
      valueName: "",
      selectValue: 1,
      height: 0,
      value: [],
      selectArr: [
        {
          label: "标题",
          value: "1",
        },
        {
          label: "创作人员",
          value: "0",
        },
      ],
      columns: [
        {
          title: "标题",
          dataIndex: "title",
          ellipsis: true,
           customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        }
        },
        {
          title: "内容模型",
          dataIndex: "modelNames",
          width: 120,
          ellipsis: true,
        },
        {
          title: "稿件状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
           width: 120,
          ellipsis: true,
        },
        {
          title: "关联栏目",
          dataIndex: "columnName",
          scopedSlots: { customRender: "columnName" },
           width: 120,
          ellipsis: true,
        },
        {
          title: "创作人员",
          dataIndex: "manName",
           width: 120,
          ellipsis: true,
        },
        {
          title: "日志",
          dataIndex: "stateRizhi",
          scopedSlots: { customRender: "stateRizhi" },
           width: 120,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 174,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      columnId: "",
      customSlot: [
        {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
        {
          name: "state",
          customRender: "state",
        },
         {
          name: "columnName",
          customRender: "columnName",
        },
      ],
       columnsTwo: [
        {
          title: "关联栏目",
          dataIndex: "columnName",
           width: 120,
          ellipsis: true,
        },
        {
          title: "状态",
          dataIndex: "state",
           scopedSlots: { customRender: "state" },
            width: 120,
          ellipsis: true,
        },
      ],
       customSlotTwo:[
         {
          name: "state",
          customRender: "state",
        },
      ],
      rowKeys: [],
      seeData: {},
      loading: false,
      isSelectRow: true,
      listPageData: [],
      loading: false,
      dialogVisibleTwo:false,
       dataSourceColunm: [],
      itemColumn: {},
      dialogVisibleColum: false,
      codeData:[],
      showDataReq:[],
    };
  },
  components: {
    coententTable,
  },
  mounted() {
    this.getList();
    this.getListPage();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
     handleCloseColum() {
      this.dialogVisibleColum = false;
      //this.getList()
    },
    release(item) {
      toColumnExamine([
        {
          manuscriptId: this.itemColumn.id,
          id: item.id,
          columnId: item.columnId,
        },
      ]).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
            }
          });
        }
      });
    },
    Offline(item) {
      toColumnOffline([
        {
          manuscriptId: this.itemColumn.id,
          id: item.id,
          columnId: item.columnId,
        },
      ]).then((res) => {
        if (res.code == 0) {
          selectList({ id: this.itemColumn.id }).then((res) => {
            if (res.code == 0) {
              this.dataSourceColunm = res.data;
            }
          });
        }
      });
    },
    openColumn(item) {
      this.dialogVisibleColum = true;
      this.itemColumn = item;
      selectList({ id: item.id }).then((res) => {
        if (res.code == 0) {
          this.dataSourceColunm = res.data;
        }
      });
    },
    getListPage() {
      listPage({
        siteId: sessionStorage.getItem("siteId"),
        current: 1,
        size: 100000000,
      }).then((res) => {
        if (res.code == 0) {
          this.listPageData = JSON.parse(JSON.stringify(res.data.records));
        }
      });
    },
    see(item) {
      selectListById({
        id: item.id,
      }).then((res) => {
        if (res.code == 0) {
          this.seeData = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    handleMenuClick(e) {
      let content = "";
      console.log(this.rowKeys,'dasdasd');
      if(this.rowKeys.length == 0){
          message.error('请选择操作项');
          return false;
      }
      if (e.key == 1) {
        content = "确定批量还原吗?";
      }
      if (e.key == 2) {
        content = "确定批量删除吗?";
      }
      const _this = this;
      this.$confirm({
        title: "操作提示",
        content,
        centered: true,
        onOk() {
           return new Promise((resolve, reject) => {
              if (e.key == 1) {
              reduction({
                idList: _this.rowKeys,
              }).then((res) => {
                if (res.code == 0) {
                  setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                  _this.getList();
                  _this.rowKeys = [];
                }
              });
            }
            if (e.key == 2) {
              recycleByDelete({
                idList: _this.rowKeys,
              }).then((res) => {
                if (res.code == 0) {
                  setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                  _this.getList();
                  _this.rowKeys = [];
                }
              });
          }
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
        class: "test",
      });
    },
    selectFn(value) {
      this.selectValue = value;
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    editAdmin(item) {
        this.$router.push({
            path: "/index/content/manuscripts_edit",
            query: {
                id:item.id,
                isAllman:true,
            },
        });
    },
     showData(id) {
      this.showDataReq = [];
      selectList({ id: id }).then((res) => {
        if (res.code == 0) {
          this.showDataReq = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    getList() {
      this.loading = true;
      selectRecycleListPage({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        value: this.valueName,
        siteId: sessionStorage.getItem("siteId"),
        type: this.selectValue,
        labelType: 3,
        modelId: this.value.join(","),
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        if(this.pagination.total > 0){
          this.height = document.documentElement.clientHeight - 400;
          window.onresize = () => {
              return (() => {
                this.height = document.documentElement.clientHeight - 400;
              })();
            };
        }
        if(this.pagination.current !=1 && this.dataSource.length == 0){
            this.pagination.current--
            this.getList()
        }
        this.loading = false;
      });
    },
    onShowSizeChange(current) {
      console.log();
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    selectedRowKeys(keys) {
      this.rowKeys = keys;
    },
    handleTableChange() {},
    handleClose(){
        this.dialogVisibleTwo = false
    },
    open(item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.dialogVisibleTwo = true;
    },
    deleteOne() {
      recycleByDelete({
        idList: [this.item.id],
      }).then((res) => {
        if (res.code == 0) {
            this.dialogVisibleTwo = false;
          this.getList();
        }
      });
    },
    reductionOne(item) {
      reduction({
        idList: [item.id],
      }).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    reject(item) {
      examineFail({
        idList: [item.id],
      }).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  .search {
    padding: 24px;
    display: flex;
    width: 100%;
    padding-bottom: 0px;
    justify-content: space-between;
    .left {
      display: flex;
    }
    .icon-search-folder:before {
      color: #fff;
      margin-right: 5px;
    }
    .batch-operation {
      /deep/ .ant-btn,
      .ant-dropdown-trigger {
        height: 40px;
        background: #ecf5ff;
        color: #18abff;
        border-color: #c9e3ff;
        text-align: center;
      }
    }
    .right {
      display: flex;
      width: 580px;
      /deep/ .ant-select-selection {
        background: #f7f7f7;
        height: 40px;
      }
      /deep/ .ant-input {
        background: #f7f7f7;
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background: #f7f7f7;
      }
      /deep/ input::-webkit-input-placeholder {
        color: #415058;
      }
      /deep/ .ant-select-selection__placeholder {
        color: #415058;
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
}
.column-style {
  display: flex;
  cursor: pointer;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
.el-button--primary {
  background: #176de6;
}
.title-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 10px;
  .title-top-left {
    height: 17px;
    color: rgba(48, 49, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
  .title-top-right {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: right;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.column-number {
  padding: 0 10px;
  height: 20px;
  border-radius: 3px;
  background-color: rgba(236, 245, 255, 1);
  color: rgba(64, 158, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(217, 236, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
}
.column-numberTwo {
  width: 56px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
}
.column-box{
   /deep/ .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{
     background: #fff;
   }
}
.column-box {
  /deep/ .table {
    margin-bottom: 24px;
    margin-left: 0;
    margin-right: 0;
  }
  /deep/
    .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #fafafa;
  }
}
.item-one {
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-bottom: 5px;
  line-height: 20px;
}
</style>